<template>
    <v-card rounded="lg" :color="cardColor" :dark="dark" max-width="400px">
        <v-card-title>
            <div :style="cardTitleStyle">{{ title }}</div>
            <v-spacer></v-spacer>
            <v-icon :color="iconColor" small>mdi-cog</v-icon>
        </v-card-title>
        <v-card-text>
            <v-container fluid class="pa-0">
                <v-row v-for="(info, index) in infos" :key="index" no-gutters>
                    <v-col cols="4" class="py-1 px-0 d-flex align-center">
                        <div class="text-no-wrap responsive-text" :style="getResponsiveTextStyle(info.label)">{{ info.label }}</div> 
                    </v-col>
                    <v-col cols="2" class="py-1 px-0 d-flex align-center">
                        <div class="text-no-wrap responsive-text" :style="getResponsiveTextStyle(info.value)">{{ info.value }}</div>
                    </v-col>
                    <v-col cols="6" class="py-1 px-0 d-flex align-center">
                        <template v-if="info.percentage !== undefined">
                            <div class="percent-container">
                                <PercentItem 
                                    :value="info.percentage"
                                    :dark="dark"
                                />
                            </div>
                        </template>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
import PercentItem from '../PercentItem.vue'

export default {
    name: 'DataCard',
    components: {
        PercentItem
    },
    props: {
        title: {
            type: String,
            default: 'Dados'
        },
        items: {
            type: Array,
            default: () => []
        },
        dark: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        
    }),
    computed: {
        cardColor() {
            return this.dark ? 'grey-darken-3' : 'white'
        },
        iconColor() {
            return this.dark ? 'white' : 'primary'
        },
        cardTitleStyle() {
            return {
                fontSize: '1.5rem',
                fontWeight: '600',
                color: this.dark ? 'white' : this.$vuetify.theme.currentTheme.primary
            }
        },
        infos() {
            return this.items.map(item => {
                return {
                    label: item.label,
                    value: item.value,
                    percentage: item.percentage
                }
            })
        }
    },
    methods: {
        getResponsiveTextStyle(text) {
            // Base font size that will be adjusted
            let baseSize = 14;
            
            // Adjust font size based on text length and screen size
            if (text && text.length > 20) {
                baseSize = Math.max(12, baseSize - 2);
            }
            if (text && text.length > 30) {
                baseSize = Math.max(10, baseSize - 4);
            }
            
            // Responsive adjustments based on screen size
            if (this.$vuetify.breakpoint.smAndDown) {
                baseSize = Math.max(10, baseSize - 2);
            }
            if (this.$vuetify.breakpoint.xs) {
                baseSize = Math.max(8, baseSize - 4);
            }
            
            return {
                fontSize: `${baseSize}px`,
                lineHeight: '1.0',
                fontWeight: 'bold',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                color: this.dark ? 'white' : 'inherit'
            }
        }
    }
}

</script>

<style scoped>
.responsive-text {
    transition: font-size 0.2s ease;
    text-align: center;
}

.percent-container {
    width: 100%;
    overflow: hidden;   
    padding-bottom: 5px;
    text-align: center;
}

/* Dark mode specific styles */
.v-card--dark .responsive-text {
    color: white !important;
}

.v-card--dark .v-card__title {
    border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}

.v-card--dark .v-card__text {
    color: rgba(255, 255, 255, 0.87);
}
</style>